import React from 'react'
import {Link}  from 'react-router-dom'
import HeaderTopbar from '../HeaderTopbar'
import MobileMenu from '../../components/MobileMenu'
import './style.css'

const Header = (props) => {
    const SubmitHandler = (e) =>{
        e.preventDefault()
     }

     const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(	
        <div className={`middle-header ${props.headerClass}`}>
            <HeaderTopbar/>
            <div className="header-style-1">
                <div className="container">
                    <div className="header-content">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                            <div className="logo">
                                <Link onClick={ClickHandler} to="/" title=""><img src={props.Logo} alt=""/></Link>
                            </div>
                        </div>
                        <div className="col-lg-9 d-lg-block d-none">
                            <nav>
                                <ul>
                                    <li><Link onClick={ClickHandler} className="active" to="/" title="">Home</Link>
                                       </li>
                                    <li className="menu-item-has-children">
                                        <Link to="#services">Services</Link>
                                    </li>
                                    <li><Link onClick={ClickHandler} to="/blog">Packages</Link></li>
                                    <li><Link onClick={ClickHandler} to="#about" title="">About</Link></li>
                                    <li><Link onClick={ClickHandler} to="" title="">Policies</Link>
                                        <ul>
                                            <li><Link onClick={ClickHandler} to="/service">Service</Link></li>
                                            <li><Link onClick={ClickHandler} to="/service-single">Service single</Link></li>
                                            <li><Link onClick={ClickHandler} to="/pricing">Pricing</Link></li>
                                            <li><Link onClick={ClickHandler} to="/faq">FAQ</Link></li>
                                            <li><Link onClick={ClickHandler} to="/404" title="">Error 404</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link onClick={ClickHandler} to="/contact" title="">Contact</Link></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-2 col-2">
                            <MobileMenu/>
                        </div>
                    </div>
                    
                        <div className="clearfix"></div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Header;